export const DRIVE_FREQUENCIES = ['hourly', 'daily', 'weekly', 'monthly'] as const;

export const DRIVE_FREQUENCY_LABELS: Record<string, string> = {
  hourly: 'Hourly',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
};

export const DRIVE_LINK_ROLES = ['role_reseller', 'role_cadmin', 'role_ccadmin'];

export function normalizeDriveFrequencies(options: unknown): string[] {
  const list = Array.isArray(options) ? options.map((value) => String(value).trim()) : [];
  return DRIVE_FREQUENCIES.filter((value) => list.includes(value));
}

export function getParentGrantableDriveFrequencies(moduleOperations: any, isSuperAdmin: boolean): string[] {
  if (isSuperAdmin) return [...DRIVE_FREQUENCIES];
  const entry = moduleOperations?.Users;
  if (!entry?.add && !entry?.edit) return [];
  return normalizeDriveFrequencies(entry?.drive_frequencies);
}

export function formatDriveFrequenciesLabel(entry: any): string {
  const selected = normalizeDriveFrequencies(entry?.drive_frequencies);
  if (!selected.length) return '—';
  return selected.map((value) => DRIVE_FREQUENCY_LABELS[value] || value).join(', ');
}

export function normalizeDriveFrequenciesForSave(options: unknown, grantable: string[]): string[] {
  const allowed = new Set(normalizeDriveFrequencies(grantable));
  return normalizeDriveFrequencies(options).filter((value) => allowed.has(value));
}
